// extracted by css-extract-rspack-plugin
export default {"cls1":"TransactionalPricingModal-cls1_Lo5","cls2":"TransactionalPricingModal-cls2_Buq TransactionalPricingModal-cls1_Lo5"};